import { gql } from '@apollo/client';

export function updateMaxCreditLimit() {
  return gql`
    mutation updateMaxCreditLimit(
      $entityId: String!
      $maxCreditLimitAllowedCurrency: String!
      $maxCreditLimitAllowed: Long!
    ) {
      salesforceManagement {
        entities {
          businessPartner {
            salesforceManagement {
              updateMaxCreditLimit(
                entityId: $entityId
                maxCreditLimitAllowedCurrency: $maxCreditLimitAllowedCurrency
                maxCreditLimitAllowed: $maxCreditLimitAllowed
              ) {
                id
                views {
                  SalesforceManagement_all {
                    properties {
                      MaxCreditLimitAllowedCurrency {
                        Code
                        Title
                      }
                      MaxCreditLimitAllowed
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;
}
